/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Member {

    import fld = MbReport_01_Dt_PluRow.Fields;
    @Serenity.Decorators.registerClass()
    export class MbReport_01_Dt_Plu_PluEditor extends Serenity.Extensions.GridEditorBase<MbReport_01_Dt_PluRow> {
        protected getColumnsKey() { return "Member.MbReport_01_Dt_Plu"; }
        protected getDialogType() { return MbReport_01_Dt_PluDialog; }
        protected getLocalTextPrefix() { return MbReport_01_Dt_PluRow.localTextPrefix; }
        protected getService() { return MbReport_01_Dt_PluService.baseUrl; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }   
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-30));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["ShopId"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "ShopId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["ShopId"];
            //     };
            // }


            return filters;
        }   

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: MbReport_01_Dt_PluService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
           

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('GrossSales'),
                    new Slick.Aggregators.Sum('AllItemDiscount'),
                    // new Slick.Aggregators.Sum('AllItemCharge'),
                    new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('VatOfNetSales'),
                    // new Slick.Aggregators.Sum('VatOfCharge')
                ]
            });
            return grid;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

